export default "__VITE_ASSET__mZSB3RHr__"